import { Injectable, Injector } from '@angular/core';
import {
  Controller,
  HttpPost,
  FromBody,
  resultOf,
  Produce,
  HttpStatusResult,
} from '@jct/core';
import { ErrorsModel} from './error.types';

@Injectable({ providedIn: 'root' })
@Controller('errors')
export class ErrorService {
  constructor(protected injector: Injector) {}

  @HttpPost('send-support-email')
  @Produce(HttpStatusResult)
  sendSupportEmail(
    @FromBody('errorsModel')
    errorsModel: ErrorsModel) {
    return resultOf();
  }
  
}
